import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import SearchIcon from '@material-ui/icons/Search';
import { useState } from 'react';
import { mask } from 'remask';
import { listDisjuntores } from '../../utils/constants';
import Dialogoconfirmacao from '../Dialogoconfirmacao';

export default function FormEditProjectSolarEnergy({ dados, ...props }) {
  const [listInverters, setListInverters] = useState(
    dados?.data?.inverters || []
  );

  const [showConfirmModal, setShowConfirmModal] = useState({
    status: false,
    width: 'sm',
    title: 'Confirmar',
    description: '',
    btn_conf: 'Sim',
    btn_cancel: 'Não',
    delete: true,
    dados: '',
    temp: '',
  });

  const handleAddInverter = () => {
    let aux = listInverters;
    aux.push({
      power_kwp: '',
      model: '',
      amount: '',
    });

    setListInverters([...aux]);
  };

  const handleChangeInverter = (idx, field, value) => {
    let aux = listInverters;

    aux[idx][field] = value;

    setListInverters([...aux]);
    props.setDados({
      ...dados,
      data: { ...dados.data, inverters: listInverters },
    });
  };

  const handleRemoveInverter = (idx) => {
    let aux = listInverters;
    aux.splice(idx, 1);
    setListInverters([...aux]);
  };

  return (
    <>
      <section>
        <h4>Informações da Instalação - Unidade Geradora</h4>

        <div className="div__multiColumn">
          <select
            className="input-custom-style "
            required
            name="data.breaker_type"
            style={{ flex: 1 }}
            value={dados.data?.breaker_type || ''}
            onChange={props.onInputChange}
          >
            <option value="" disabled>
              Tipo de disjuntor
            </option>
            <option value="monofásico">Monofásico</option>
            <option value="bifásico">Bifásico</option>
            <option value="trifásico">Trifásico</option>
          </select>

          <select
            required
            name="data.breaker_value"
            style={{ flex: 2 }}
            value={dados.data?.breaker_value || ''}
            onChange={props.onInputChange}
          >
            <option value="" disabled>
              Valor do disjuntor
            </option>
            {listDisjuntores.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>

          {dados.data?.breaker_value === 'Outro' && (
            <input
              type="number"
              min={0}
              name="data.other_breaker_value"
              value={dados.data?.other_breaker_value ? `${dados.data?.other_breaker_value}` : ''}
              placeholder="Valor do disjuntor em A"
              style={{
                flex: 1,
              }}
              onChange={props.onInputChange}
              required={dados.data?.breaker_value === 'Outro'}
            />
          )}
        </div>

        <div className="div__multiColumn" style={{ maxWidth: '530px' }}>
          <input
            className="input-custom-style "
            type="number"
            placeholder={'Latitude do projeto'}
            value={dados.latitude || ''}
            onChange={props.onInputChange}
            name={'latitude'}
            style={{ flex: 1 }}
            required
          />
          <input
            className="input-custom-style "
            type="number"
            placeholder={'Longitude do projeto'}
            value={dados.longitude || ''}
            onChange={props.onInputChange}
            name={'longitude'}
            style={{ flex: 1 }}
            required
          />

          <button
            type="button"
            className="tertiary-button-style"
            style={{
              alignItems: 'center',
              display: 'flex',
            }}
            onClick={() => props.setShowCoord(!props.showCoord)}
          >
            <SearchIcon /> Buscar
          </button>
        </div>
      </section>

      <section>
        <div className="div__contHeader">
          <h4>Especificações do Projeto</h4>

          <button
            type="button"
            className="tertiary-button-style"
            onClick={handleAddInverter}
          >
            + Inversor
          </button>
        </div>

        {listInverters.length ? (
          listInverters?.map((invert, idx) => (
            <div
              className="div__multiColumn"
              style={{ maxWidth: '100%' }}
              key={idx}
            >
              <div className="div__contInputPosField">
                <input
                  className="input-custom-style "
                  type="text"
                  name="amount"
                  value={invert.amount}
                  placeholder="Qtd. de inversores"
                  style={{
                    flex: 1,
                  }}
                  onChange={(e) => {
                    handleChangeInverter(
                      idx,
                      'amount',
                      mask(e.target.value, '999')
                    );
                  }}
                  required
                />
                <span className="pos_field">Inversor(es)</span>
              </div>

              <div className="div__contInputPosField">
                <input
                  className="input-custom-style "
                  type="number"
                  min="0"
                  step="0.01"
                  name="power_kwp"
                  value={invert.power_kwp}
                  placeholder="Potência"
                  style={{
                    flex: 1,
                  }}
                  onChange={(e) => {
                    handleChangeInverter(
                      idx,
                      'power_kwp',
                      Number(mask(e.target.value, '999'))
                    );
                  }}
                  required
                />
                <span className="pos_field">kWp</span>
              </div>

              <input
                className="input-custom-style "
                type="text"
                name="inverters_model"
                value={invert.model}
                placeholder="Modelo dos inversores"
                style={{ flex: 2 }}
                onChange={(e) => {
                  handleChangeInverter(idx, 'model', e.target.value);
                }}
              />

              <HighlightOffIcon
                style={{
                  color: 'var(--delete)',
                  cursor: 'pointer',
                  zIndex: '99991',
                }}
                onClick={() =>
                  setShowConfirmModal({
                    ...showConfirmModal,
                    status: true,
                    dados: invert,
                    removeInverter: true,
                    width: 'sm',
                    title: 'Confirmar',
                    description:
                      'Deseja realmente remover o inversor do projeto?',
                  })
                }
              />
            </div>
          ))
        ) : (
          <div className="div__nada">Nenhum inversor cadastrado</div>
        )}
      </section>

      {showConfirmModal.status && (
        <Dialogoconfirmacao
          status={showConfirmModal.status}
          width={showConfirmModal.width}
          delete={showConfirmModal.delete}
          description={showConfirmModal.description}
          fechar={() =>
            setShowConfirmModal((s) => ({
              ...s,
              dados: '',
              status: false,
              temp: '',
            }))
          }
          confirmar={() => {
            if (showConfirmModal.removeInverter) {
              handleRemoveInverter();
            }
          }}
        />
      )}
    </>
  );
}
